import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tailwind.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json';
import './utils/api'; // Import API utilities to ensure proper configuration
import { enableLogging, disableLogging } from './utils/logger';
import TranslationWrapper from './components/TranslationWrapper';

// if href is localhost, enable logging
if (window.location.href.includes('localhost')) {
    enableLogging();  // Turn on logging
} else {
    disableLogging(); // Turn off logging
}

Amplify.configure(config);

// Load initial language settings from localStorage or use browser settings
// RTL languages: Arabic (ar), Kurdish (ku)
const RTL_LANGUAGES = ['ar', 'ku'];

if (typeof window !== 'undefined') {
    const initialLanguage = localStorage.getItem('language-storage');
    if (initialLanguage) {
        try {
            const { state } = JSON.parse(initialLanguage);
            if (state.language) {
                document.documentElement.lang = state.language;
                const isRTL = RTL_LANGUAGES.includes(state.language);
                document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
                if (isRTL) {
                    document.body.classList.add('rtl');
                } else {
                    document.body.classList.remove('rtl');
                }
            }
        } catch (e) {
            console.error('Error parsing language settings:', e);
        }
    }
}

// Match the mobile browser / status bar colour to the app header; dark mode is toggled from several places
const themeColorMeta = document.querySelector('meta[name="theme-color"]');
if (themeColorMeta) {
    const syncThemeColor = () => {
        themeColorMeta.setAttribute('content', document.documentElement.classList.contains('dark') ? '#111827' : '#ffffff');
    };
    syncThemeColor();
    new MutationObserver(syncThemeColor).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <TranslationWrapper>
        <App />
    </TranslationWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
